import {apiPost, API_URL} from '../api'

export const editReportState = async (id: string, checked: boolean) => {
    const {data} = await apiPost(API_URL, 'admin/report_check', {id: id, checked: checked})
    return data
}
